module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Pomodoro.cc98795f.jpg";